<template>
    <div id="app">
        <canvas id="myCanvas" height="930" width="1500"></canvas>
    </div>
</template>
<script>
import paper from "paper";
import imagePin from "../../../public/pin_flat2.svg";
export default {
    name: " canvasPin",
    props: ["elements"],

    mounted: function() {
        this.makeCanvas();
    },
    watch: {
        elements: [
            {
                handler: "makeCanvas"
            }
        ]
    },
    methods: {
        getRandomIntInclusive(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min + 1)) + min;
        },
        makeCanvas() {
            let canvas = document.getElementById("myCanvas");

            paper.setup(canvas);
            this.elements.forEach(element => {
                let image = require(`../../../public/img/icon/${element.icon}.svg`);
                let x = this.getRandomIntInclusive(100, 1300);
                let y = this.getRandomIntInclusive(90, 800);
                let self = this;
                let test;
                paper.project.importSVG(imagePin, function(item) {
                    let circleColor = item.children["couleur"];
                    let fond = item.children["fond"];
                    circleColor.fillColor = element.color;
                    let squareIcon1 = item.children["squareIcon"];

                    item.importSVG(image, function(item2) {
                        item2.fitBounds(squareIcon1.bounds);
                        test = item2;
                        squareIcon1.remove();
                    });

                    item.scale(0.2, item.bounds.topLeft);

                    item.position = new paper.Point(x, y);
                    item.onMouseEnter = function() {
                        circleColor.fillColor = "#eef4e0";
                        fond.fillColor = element.color;
                        test.fillColor = element.color;
                    };
                    item.onMouseLeave = function() {
                        circleColor.fillColor = element.color;
                        fond.fillColor = "#eef4e0";
                        test.fillColor = "#eef4e0";
                    };
                    function leave() {}

                    item.onClick = function() {
                        this.onMouseLeave = leave;
                        self.$emit("pin-click", element.index);
                    };
                });
            });
        }
    }
};
</script>
